import type { Query, QueryClient } from '@tanstack/react-query'
import type { CampaignInfo } from 'app/src/model'
import type { membershipApi } from 'app/src/services/welfareportal'
import { queryClient } from 'app/src/shared/helpers'
import { useMembershipPatch as useMembershipPatchOriginal } from './membership-components'

const useMembershipPatch = (...args: Parameters<typeof useMembershipPatchOriginal>) => {
  return useMembershipPatchOriginal({
    ...args?.[0],
    onSuccess: (data, variables, context) => {
      args?.[0]?.onSuccess?.(data, variables, context)
      invalidateCacheByOperationId(queryClient, 'membership-api.userMembershipActiveGet')
    },
  })
}

const getPhaseAndDeadline = (campaignInfo: membershipApi.CompanyWelfareCampaign): CampaignInfo => {
  let result: CampaignInfo = { phase: campaignInfo.phase }
  switch (campaignInfo.phase) {
    case 'pre-join':
      result.deadline = campaignInfo.joinDateFrom
      break
    case 'join':
      result.deadline = campaignInfo.joinDateTo
      break
    case 'pre-fruition':
      result.deadline = campaignInfo.fruitionDateFrom
      break
    case 'fruition':
      result.deadline = campaignInfo.fruitionDateTo
      break
    default:
      break
  }

  return result
}

function invalidateCacheByOperationId(queryClient: QueryClient, ...operationIdsToBeInvalidated: AllQueryOperationsIds[]): void {
  void queryClient.invalidateQueries({
    predicate: (query: Query) => {
      const [queryOperationId] = query.queryKey

      if (typeof queryOperationId === 'string') {
        return operationIdsToBeInvalidated.includes(queryOperationId as AllQueryOperationsIds)
      }

      return false
    },
  })
}

type QueryOperationApiPrefixes = {
  membershipApi: 'membership-api.'
}

type AllQueryOperationsIds = `${QueryOperationApiPrefixes['membershipApi']}${membershipApi.QueryOperation['operationId']}`

function getQueryOperationIdWithPrefix(
  prefix: QueryOperationApiPrefixes[keyof QueryOperationApiPrefixes],
  operationId: string,
): string {
  return `${prefix}${operationId}`
}

export { getPhaseAndDeadline, getQueryOperationIdWithPrefix, invalidateCacheByOperationId, useMembershipPatch }
